<script>
import { mapActions } from 'vuex';

export default {
  name: 'VisitGroupAddonAccommodations',
  props: {
    id: {
      type: Number,
      required: true,
    },
    addonName: {
      type: String,
      required: true,
    },
    accommodations: {
      type: Array,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    showAccommodations: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    sortedAccommodations() {
      return [ ...this.accommodations ].sort(
        (a, b) => (a.xmlChannelProductTbName > b.xmlChannelProductTbName ? 1 : -1),
      );
    },
  },
  methods: {
    ...mapActions({
      close: 'visitgroup/closeAddonAccommodationModal',
    }),
  },
};
</script>

<template>
  <v-layout>
    <v-flex xs12 class="text-xs-right">
      <v-dialog
        v-model="showAccommodations"
        width="1000"
        @input="close"
      >
        <v-card tile>
          <v-layout row>
            <v-flex>
              <div class="pt-3 pl-3 font-weight-bold">
                {{ addonName }}
              </div>
              <div class="pl-3 caption">( {{ id }} )</div>
            </v-flex>
            <v-flex>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="red darken-1"
                  flat
                  @click="close"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
          <v-card-text>
            <div
              v-for="(accommodation, index) in sortedAccommodations"
              :key="index"
            >
              {{ accommodation.xmlChannelProductTbName }} (ID: {{ accommodation.xmlChannelProductId }})
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>




// WEBPACK FOOTER //
// src/components/ski/visitgroup/VisitGroupAddonAccommodations.vue